export const getWhyForYou = (allPupImages) => [
  {
    title: 'Great for Apartment Living',
    body:
      'Our pups tend to be on the smaller side, making them ideal for cozy spaces and city living without sacrificing personality.',
    image: allPupImages[1]
  },
  {
    title: 'Family-Friendly',
    body:
      'These pups are gentle, loving, and easy to bond with — perfect for families with children or first-time pet parents.',
    image: allPupImages[3]
  },
  {
    title: 'Low to Moderate Shedding',
    body:
      'Many of the puppies we place are loved for their manageable coats, making them a great choice for families looking for low-maintenance grooming.',
    image: allPupImages[5]
  },
  {
    title: 'Loyal Lap Dogs',
    body:
      "Whether you're working from home or relaxing on the weekends, our pups thrive on companionship and love to snuggle.",
    image: allPupImages[7]
  },
  {
    title: 'Social & Easy to Train',
    body: 'Raised in nurturing, hands-on environments, our plush pups come ready to learn, play, and love.',
    image: allPupImages[9]
  },
  {
    title: 'Adaptable & Travel-Ready',
    body:
      'Whether you’re staying local or frequently on the move, these pups adjust well to new environments and travel.',
    image: allPupImages[11]
  }
];

export const getProcessSteps = (allPupImages) => [
  {
    title: 'Up-to-date immunization records',
    body:
      "Each puppy comes with current immunization records detailing vaccinations and preventive care they've received.",
    icon: allPupImages[0]
  },
  {
    title: 'Comfort plush toy included',
    body: 'We include a plush toy for comfort and familiarity to help your pup settle into their new home with ease.',
    icon: allPupImages[2]
  },
  {
    title: 'Smooth pickup & handoff',
    body: 'Clear communication and a calm, safe handoff so your pup transitions confidently into their forever home.',
    icon: allPupImages[4]
  },
  {
    title: 'Shipping guidance (tap icon)',
    body: 'Questions about delivery or shipping? Tap a puppy icon to message us on WhatsApp for details.',
    icon: allPupImages[6]
  }
];

export const getOurPupsBlocks = (brand) => [
  {
    eyebrow: '🐾',
    title: 'OUR PUPS MAKE THE\nPERFECT COMPANION',
    body: `At ${brand}, we specialize in small and toy-sized companions known for their charm, adaptability, and affectionate personalities. While our inventory may change, many of our plush pups share the following qualities that make them perfect additions to any home:`,
    points: [
      'Raised with Love, Care & Early Socialization',
      'Family-Friendly, gentle temperaments',
      'Low to Moderate Shedding (varies by pup)',
      'Adaptable & travel-ready companions'
    ],
    cta: 'View Available Puppies',
    video: '/videos/reviews/review-01.mp4'
  },
  {
    eyebrow: '🐾',
    title: 'WHY PLUSH PUPS\nIS FOR YOU!',
    body:
      'These pups are loved for their charm, loyalty, and easy-to-bond personalities — a great fit for first-time pet parents and families.',
    points: [
      'Great for Apartment Living',
      'Loyal lap dogs who love to snuggle',
      'Social & easy to train',
      'Seamless, worry-free process'
    ],
    cta: 'Shop Available Pups',
    video: '/videos/reviews/review-02.mp4'
  },
  {
    eyebrow: '🐾',
    title: 'LOOKING FOR\nA PUP?',
    body:
      "Whether you're looking for a cuddle buddy, a playful pal for the kids, or a picture-perfect companion, we specialize in pairing families with the right fit.",
    points: ['Thoughtful matching', 'Safe meetups', 'After-adoption support', 'Clear communication'],
    cta: 'Message on WhatsApp',
    video: '/videos/reviews/review-03.mp4'
  },
  {
    eyebrow: '🐾',
    title: 'RAISED WITH CARE,\nCLEARED FOR LOVE.',
    body: 'Our goal is a joyful, safe start in a forever home — with guidance from first message to pickup day.',
    points: ['Hypoallergenic options', 'Comfort-first handling', 'Healthy routines', 'Happy homes'],
    cta: 'See Our Pups',
    video: '/videos/reviews/review-04.mp4'
  }
];

export const REVIEWS = [
  {
    src: '/images/reviews/review-01.jpeg',
    title: '“Absolutely in love!”',
    caption: '“Communication was fast and clear. Our pup settled in the same day.”'
  },
  {
    src: '/images/reviews/review-02.jpeg',
    title: '“So gentle and playful”',
    caption: '“You can tell they’re raised with care. Perfect temperament for our family.”'
  },
  {
    src: '/images/reviews/review-03.jpeg',
    title: '“Smooth process”',
    caption: '“Everything was organized and simple. We felt supported the whole way.”'
  },
  {
    src: '/images/reviews/review-04.jpeg',
    title: '“Highly recommended”',
    caption: '“Our pup is healthy, happy, and already part of the family.”'
  },
  {
    src: '/images/reviews/review-05.jpeg',
    title: '“Worth every bit”',
    caption: '“From first message to pickup day, everything felt professional and caring.”'
  },
  {
    src: '/images/reviews/review-06.jpeg',
    title: '“Amazing experience”',
    caption: '“We got updates, guidance, and quick answers. Thank you so much!”'
  },
  {
    src: '/images/reviews/review-07.jpeg',
    title: '“Perfect match”',
    caption: '“They helped us choose the right pup for our lifestyle. We’re so happy.”'
  },
  {
    src: '/images/reviews/review-08.jpeg',
    title: '“So much love”',
    caption: '“Our pup is affectionate and confident. You can tell they’re well-socialized.”'
  },
  {
    src: '/images/reviews/review-09.jpeg',
    title: '“Support after adoption too”',
    caption: '“Even after we brought our pup home, they still checked in and helped.”'
  },
  {
    src: '/images/reviews/review-10.jpeg',
    title: '“The sweetest little personality”',
    caption: '“Healthy, playful, and already bonding with the kids — we couldn’t be happier.”'
  },
  {
    src: '/images/reviews/review-11.jpeg',
    title: '“Quick replies, zero stress”',
    caption: '“Every question was answered fast. The whole process felt simple and reassuring.”'
  },
  {
    src: '/images/reviews/review-12.jpeg',
    title: '“Exactly what we hoped for”',
    caption: '“Beautiful pup, great temperament, and clear communication from start to finish.”'
  },
  {
    src: '/images/reviews/review-13.jpeg',
    title: '“So tiny, so perfect”',
    caption: '“You can tell they’re raised with love — confident, calm, and cuddly.”'
  },
  {
    src: '/images/reviews/review-14.jpeg',
    title: '“Trusted and professional”',
    caption: '“We felt supported the entire time. Smooth handoff and a happy, healthy pup.”'
  },
  {
    src: '/images/reviews/review-15.jpeg',
    title: '“Fast, friendly, and honest”',
    caption: '“They kept us updated and set clear expectations. Highly recommend.”'
  },
  {
    src: '/images/reviews/review-16.jpeg',
    title: '“Our new best friend”',
    caption: '“Sweet, social, and already following us everywhere. Love at first sight.”'
  },
  {
    src: '/images/reviews/review-17.jpeg',
    title: '“Care you can feel”',
    caption: '“The guidance and support made the transition easy. We’re obsessed with our pup.”'
  },
  {
    src: '/images/reviews/review-18.jpeg',
    title: '“Perfect for apartment living”',
    caption: '“Small size, big love. Settled in quickly and sleeps peacefully.”'
  },
  {
    src: '/images/reviews/review-19.jpeg',
    title: '“A smooth, happy experience”',
    caption: '“From selection to pickup, everything was clear and well organized.”'
  },
  {
    src: '/images/reviews/review-20.jpeg',
    title: '“Healthy, happy, and confident”',
    caption: '“Our pup arrived thriving — playful energy and a gentle heart.”'
  },
  {
    src: '/images/reviews/review-21.jpeg',
    title: '“So much better than expected”',
    caption: '“We felt safe and informed the entire way. The pup is absolutely precious.”'
  },
  {
    src: '/images/reviews/review-22.jpeg',
    title: '“We’re already planning another!”',
    caption: '“Great service, great pups, and real support — thank you Mary’s Plush Pups.”'
  }
];
